import {t} from "@lingui/core/macro";
import * as React from "react";

import {staticUrl} from "@khan/urls";

import type {AvatarModel} from "./types.ts";

type Props = {
    selectedModel: AvatarModel | null | undefined;
    showingModelGrid: boolean;
    onShowModelGridClick: () => void;
    onShowAvatarPreviewClick: () => void;
};

/**
 * A toggle button that can be used to switch between the grid view of models
 * and the avatar preview pane.
 */
export default class ViewSwitcherButton extends React.Component<Props> {
    componentDidMount() {
        // Automatically focus this button when the modal mounts
        // @ts-expect-error - TS2339 - Property 'showingModelGrid' does not exist on type 'ViewSwitcherButton'.
        this.showingModelGrid
            ? // @ts-expect-error - TS2339 - Property 'showPreviewLink' does not exist on type 'ViewSwitcherButton'. | TS2339 - Property 'showPreviewLink' does not exist on type 'ViewSwitcherButton'.
              this.showPreviewLink && this.showPreviewLink.focus()
            : // @ts-expect-error - TS2339 - Property 'showGridLink' does not exist on type 'ViewSwitcherButton'. | TS2339 - Property 'showGridLink' does not exist on type 'ViewSwitcherButton'.
              this.showGridLink && this.showGridLink.focus();
    }

    render(): React.ReactNode {
        const showModelGridButton = (
            <button
                className="button-reset view-select-button"
                onClick={this.props.onShowModelGridClick}
                ref={(ref) => {
                    // @ts-expect-error - TS2339 - Property 'showGridLink' does not exist on type 'ViewSwitcherButton'.
                    this.showGridLink = ref;
                }}
            >
                <i className="button-icon icon-th-large" />
                {t`All avatars`}
            </button>
        );

        const showAvatarPreviewButton = (
            <button
                className="button-reset view-select-button"
                onClick={this.props.onShowAvatarPreviewClick}
                ref={(ref) => {
                    // @ts-expect-error - TS2339 - Property 'showPreviewLink' does not exist on type 'ViewSwitcherButton'.
                    this.showPreviewLink = ref;
                }}
            >
                {this.props.selectedModel ? (
                    <img
                        className="button-icon"
                        src={staticUrl(this.props.selectedModel.imageSrc)}
                        alt=""
                        aria-hidden={true}
                    />
                ) : (
                    <i className="button-icon icon-user" />
                )}
                <span className="button-text">{t`Preview avatar`}</span>
            </button>
        );

        return this.props.showingModelGrid
            ? showAvatarPreviewButton
            : showModelGridButton;
    }
}
